import { LKDate } from 'loankeeper-common/helpers/Date'
import { translate } from 'loankeeper-common/helpers'
import { fieldTypes } from './constants'

export default (values, fields) => {
  const errors = {}

  fields.forEach((field) => {
    switch (fieldTypes[field.FieldDataType]) {
      case 'text':
      case 'textarea': {
        if (field.RequiredField === 1 && !values[field.FieldName]) {
          errors[field.FieldName] = translate('LKMESSAGE-ERR_REQUIRED_FIELD')
        }

        break
      }

      case 'date': {
        if (!values[field.FieldName]) {
          errors[field.FieldName] = translate('LKMESSAGE-ERR_REQUIRED_FIELD_DATE')
        }

        if (
          values[field.FieldName] &&
          (!LKDate.isValid(values[field.FieldName]) ||
            LKDate.from(values[field.FieldName]).instance.isSame(LKDate.from('01.01.1900').instance, 'day'))
        ) {
          errors[field.FieldName] = translate('LKMESSAGE-ERR_REQUIRED_FIELD_DATE')
        }

        break
      }

      case 'select': {
        if (field.RequiredField === 1 && parseInt(values[field.FieldName], 10) === 1) {
          errors[field.FieldName] = translate('LKMESSAGE-ERR_REQUIRED_FIELD')
        }

        break
      }

      case 'number':
      case 'float': {
        const allErrors = []

        if (field.RequiredField === 1 && (values[field.FieldName] === undefined || values[field.FieldName] === '')) {
          errors[field.FieldName] = translate('LKMESSAGE-ERR_REQUIRED_FIELD')
        } else if (field.FieldDefData) {
          const validators = field.FieldDefData.split(';')
          const validatorResults = []

          // it would be nice to switch foreach with reduce
          validators.forEach((validator, i) => {
            let validationPases = true
            const rules = validator.split('=')

            if (rules[0].indexOf('Validate') !== -1 && parseInt(rules[1], 10) === 1) {
              const minCheck = validators[i + 1].split('=')
              const maxCheck = validators[i + 2].split('=')

              allErrors.push(`${translate('LKMESSAGE-HINT_PROD_MIN')}${minCheck[1]}`)
              allErrors.push(`${translate('LKMESSAGE-HINT_PROD_MAX')}${maxCheck[1]}`)

              if (values[field.FieldName] < parseFloat(minCheck[1])) validationPases = false

              if (values[field.FieldName] > parseFloat(maxCheck[1])) validationPases = false

              if (validationPases) {
                validatorResults.push(true)
              } else {
                validatorResults.push(false)
              }
            }
          })

          if (!validatorResults.length || validatorResults.some((result) => result)) {
            delete errors[field.FieldName]
          } else {
            if (!errors[field.FieldName]) {
              errors[field.FieldName] = {}
            }

            errors[field.FieldName].allErrors = allErrors
          }
        }

        break
      }
      default: {
        if (field.RequiredField === 1 && !values[field.FieldName]) {
          errors[field.FieldName] = translate('LKMESSAGE-ERR_REQUIRED_FIELD')
        }
      }
    }
  })

  return errors
}
